import { render } from "./Logo.vue?vue&type=template&id=81f6ef12"
const script = {}
script.render = render

export default script